export default __webpack_public_path__ + "static/media/78.3b00a0a5.jpg";